import { toast } from "@/components/toast/CustomToast";
import type * as type from "@vTypes";

function ConfSection_hospital({
  preceptee_on,
  preceptee_shift_count,
  min_exp_per_shift,
  req_exp_nurses,
  two_offs_per_week,
  sequential_offs,
  even_nights,
  nod_noe,
  preceptor_gauge,
  off_days,
  weekly_off_group,
  not_one_night,
  off_placement_mode,
  setCurrentConfigures,
  fixed_wanted_use_yn,
  use_mid,
  off_first,
  off_swap_enabled,
}: {
  preceptee_on: boolean;
  preceptee_shift_count: boolean;
  min_exp_per_shift: number;
  req_exp_nurses: number;
  two_offs_per_week: boolean;
  sequential_offs: boolean;
  even_nights: boolean;
  nod_noe: boolean;
  preceptor_gauge: number;
  off_days: number;
  weekly_off_group: boolean;
  not_one_night: boolean;
  off_placement_mode: boolean;
  fixed_wanted_use_yn: boolean;
  use_mid: boolean;
  setCurrentConfigures: React.Dispatch<React.SetStateAction<type.ConfigObject>>;
  off_first: boolean;
  off_swap_enabled: boolean;
}) {
  return (
    <div className="conf_schedule__itemWrap w-[370px] max-w-[370px]">
      <h2 className="conf_schedule__title">부서 내규 설정</h2>
      <div className="conf_schedule__table">
        {/* Shift 내 책임 경력 최소 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap">
            Shift 내 책임 경력 최소
          </div>
          <div className={`conf_schedule__numInput`}>
            <input
              type="text"
              value={min_exp_per_shift}
              onInput={(e) => {
                const changeValue = Number(e.currentTarget.value);
                setCurrentConfigures((prev) => ({
                  ...prev,
                  min_exp_per_shift: changeValue,
                }));
              }}
            />{" "}
            년차
          </div>
        </div>

        {/* 책임 간호 인원 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap">
            책임 간호 인원
          </div>
          <div className="conf_schedule__numInput">
            <input
              type="text"
              value={req_exp_nurses}
              onInput={(e) => {
                const changeValue = Number(e.currentTarget.value);
                setCurrentConfigures((prev) => ({
                  ...prev,
                  req_exp_nurses: changeValue,
                }));
              }}
            />{" "}
            명
          </div>
        </div>

        {/* 주 2회 이상 OFF */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText">주 2회 이상 OFF</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={two_offs_per_week}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  two_offs_per_week: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* OFF 연속 배정 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText">OFF 연속 배정</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={sequential_offs}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  sequential_offs: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* 나이트 개수 균등 배정 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText">나이트 개수 균등 배정</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={even_nights}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  even_nights: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* NOE/NOD 최소화 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText">NOE/NOD 최소화</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={nod_noe}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  nod_noe: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* 프리셉터 근무 매칭 강도 */}
        {/* <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText">프리셉터 근무 매칭 강도</div>
          <div className="conf_rangeWrap">
            <input
              type="range"
              min={1}
              max={10}
              step={0.1}
              className="comp_inputRange"
              style={{
                background: `linear-gradient(to right, #d6d6de calc(${preceptor_gauge * 10}% - 0.5em), #f0f0f2 calc(${preceptor_gauge * 10}% - 0.5em)`,
              }}
              value={preceptor_gauge}
              onChange={(e) => {
                const changeValue = Number(e.currentTarget.value);
                setCurrentConfigures((prev) => ({
                  ...prev,
                  preceptor_gauge: changeValue,
                }));
              }}
            />
            <span
              style={{ width: "20px", flexShrink: "0", userSelect: "none" }}
            >
              {preceptor_gauge}
            </span>
          </div>
        </div> */}
        {/* 나이트 연속 배정 설정 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            나이트 연속 배정 (1N 금지)
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={not_one_night}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  not_one_night: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* 월 OFF 수 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap">
            월 OFF 수
          </div>
          <div className="conf_schedule__numInput">
            <input
              type="text"
              value={off_days}
              onInput={(e) => {
                const changeValue = Number(e.currentTarget.value);
                setCurrentConfigures((prev) => ({
                  ...prev,
                  off_days: changeValue,
                }));
              }}
              onBlur={() => {
                if (off_days < 8) {
                  setCurrentConfigures((prev) => ({ ...prev, off_days: 8 }));
                  // alert("8일 이상으로 설정해주세요.")
                  toast.warning(
                    "8일 미만은 불가능합니다.\n8일로 자동 조정되었습니다.",
                    { wrapperClassName: "!w-max" }
                  );
                }
              }}
            />{" "}
            일
          </div>
        </div>

        {/* 주휴 설정 */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="text-[#0E59C6] text-[16px] font-pretendard underline underline-offset-1">
            주휴 설정
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={weekly_off_group}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  weekly_off_group: isChecked,
                  off_placement_mode: isChecked
                    ? prev.off_placement_mode
                    : false,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>
        {/*  주휴 인접 OFF 우선배치 / 주휴 설정이 on되어야 사용 가능함*/}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            주휴 인접 OFF 우선배치
          </div>
          <label
            className={`conf_slideSwitch ${!weekly_off_group ? "conf_slideSwitch--disabled " : ""}`}
          >
            <input
              type="checkbox"
              checked={off_placement_mode}
              disabled={!weekly_off_group}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  off_placement_mode: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            프리셉터 팔로우 모드
          </div>
          <label className={`conf_slideSwitch  cursor-pointer`}>
            <input
              type="checkbox"
              checked={preceptee_on}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  preceptee_on: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            프리셉티 근무인원 포함
          </div>
          <label className={`conf_slideSwitch cursor-pointer`}>
            <input
              type="checkbox"
              checked={preceptee_shift_count}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  preceptee_shift_count: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            원티드 관리보드 반영
          </div>
          <label className={`conf_slideSwitch cursor-pointer`}>
            <input
              type="checkbox"
              checked={fixed_wanted_use_yn}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  fixed_wanted_use_yn: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* MID */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            근무코드 MID 사용
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={use_mid}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  use_mid: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {/* off First */}
        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            근무인원 우선
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={off_first}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  off_first: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch3">
          <div className="conf_schedule__optText conf_schedule__numInputWrap !whitespace-nowrap">
            오프 초과시 연차 전환
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={off_swap_enabled}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  off_swap_enabled: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default ConfSection_hospital;
